import { ConfigOption } from '@ngx-formly/core';
import { DeliveryTermsDropDownComponent } from './delivery-terms-drop-down/delivery-terms-drop-down.component';

export const DELIVERY_TERMS_FORMLY_TYPES: ConfigOption['types'] = [
  { name: 'formly-delivery-term-drop-down', component: DeliveryTermsDropDownComponent, wrappers: ['simple-title'] },
]
